<template>
    <div class="grid">
        <div class="col-12">
            <Card id="toolbar">
                <template #title>
                    <Toolbar>
                        <template #right>
                            <div class="p-card-title" style="margin-top:10px;">
                                <Button label="Print" icon="pi pi-print pi-fw" class="p-button-success mr-2" @click="downloadPrint()" />
                                <Button v-if="this.$IS_PRINT_DOCUMENT == 'TRUE'" label="Pdf" icon="pi pi-file-pdf pi-fw" class="p-button-danger mr-2" @click="exportToPDF" />
                                <Button label="Back" icon="pi pi-chevron-left" class="p-button-primary"  @click="backToIndex" />
                            </div>
                        </template>
                    </Toolbar>
                </template>
            </Card>
            <div class="surface-0" style="background:white;padding:0;margin:0;">
                <div id="apps" class="center">
                    <table class="table"  ref="document" style="font-family:'Times New Roman', Times, serif;font-size:9px;width:100%;" v-if="dataDocument">
                    <colgroup>
                        <col style="width: 8.33%;">  <!-- Column 1 -->
                        <col style="width: 8.33%;">  <!-- Column 2 -->
                        <col style="width: 8.33%;">  <!-- Column 3 -->
                        <col style="width: 8.33%;">  <!-- Column 4 -->
                        <col style="width: 8.33%;">  <!-- Column 5 -->
                        <col style="width: 8.33%;">  <!-- Column 6 -->
                        <col style="width: 8.33%;">  <!-- Column 7 -->
                        <col style="width: 8.33%;">  <!-- Column 8 -->
                        <col style="width: 8.33%;">  <!-- Column 9 -->
                        <col style="width: 8.33%;">  <!-- Column 10 -->
                        <col style="width: 8.33%;">  <!-- Column 11 -->
                        <col style="width: 8.33%;">  <!-- Column 12 -->
                    </colgroup>
                    <thead>
                         <tr>
                            <th colspan="12" class="no-border" style="text-align:center;"><p style="font-size:20px;">RINCIAN PEMERIKSAAN BERSAMA<br/>
                                    <span style="font-size:15px;" v-if="dataDocument">MC-{{dataDocument.Current_MC}}</span><br/>
                                    <span style="font-size:15px;" v-if="dataDocument">No. Document: {{dataDocument.Doc_No}}</span>
                                </p>
                            </th>
                        </tr>
                        <tr style="height:15px;">
                            <td colspan="12" class="no-border"></td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td colspan="2" class="no-border">Judul Pekerjaan</td>
                            <td colspan="10" class="no-border" v-if="dataDocument">: {{dataDocument!=null ? dataDocument.Deskripsi_Pekerjaan:""}}</td>
                        </tr>
                        <tr>
                            <td colspan="2" class="no-border">Company</td>
                            <td colspan="10" class="no-border" v-if="dataDocument">: {{dataDocument!=null ? dataDocument.Company:""}}</td>
                        </tr>
                        <tr>
                            <td colspan="2" class="no-border">Nama Kontractor</td>
                            <td colspan="10" class="no-border" v-if="dataDocument">: {{dataDocument!=null ? dataDocument.contractor:""}}</td>
                        </tr>
                        <tr>
                            <td colspan="2" class="no-border">No. SPO</td>
                            <td colspan="10" class="no-border" v-if="dataDocument">: {{dataDocument!=null ? dataDocument.No_SPO:""}}</td>
                        </tr>
                        <tr>
                            <td colspan="2" class="no-border">No. SPK</td>
                            <td colspan="10" class="no-border" v-if="dataDocument">: {{dataDocument!=null ? dataDocument.No_SPK:""}}</td>
                        </tr>
                        <tr>
                            <td colspan="2" class="no-border">WBS Element</td>
                            <td colspan="10" class="no-border" v-if="dataDocument">: {{dataDocument!=null ? dataDocument.WBS_Allocation:""}}</td>
                        </tr>
                        <tr>
                            <td colspan="2" class="no-border">Date of MC</td>
                            <td colspan="10" class="no-border" v-if="dataDocument">: {{this.$formatDate(dataDocument.Doc_Date)}}</td>
                        </tr>
                        <tr style="height:15px;">
                            <td colspan="12" class="no-border"></td>
                        </tr>
                        <tr style="text-align:center !important;font-weight:bold;" class="table-header">
                            <td rowspan="2" colspan="2" style="text-align:center !important;">No.</td>
                            <td rowspan="2" colspan="2" style="text-align:center !important;">Uraian Pekerjaan</td>
                            <td colspan="2" style="text-align:center !important;">{{dataDocument!=null ? dataDocument.signContract1:""}}</td>
                            <td colspan="2" style="text-align:center !important;">{{dataDocument!=null ? dataDocument.signContract2:""}}</td>
                            <td colspan="2" style="text-align:center !important;">Deviasi</td>
                            <td rowspan="2" colspan="2" style="text-align:center !important;">Keterangan</td>
                        </tr>
                        <tr style="text-align:center !important;font-weight:bold;" class="table-header"> 
                            <td style="text-align:center !important;">Volume</td>
                            <td style="text-align:center !important;">Satuan</td>
                            <td style="text-align:center !important;">Volume</td>
                            <td style="text-align:center !important;">Satuan</td>
                            <td style="text-align:center !important;">Volume</td>
                            <td style="text-align:center !important;">Satuan</td>
                        </tr>
                        <tr v-for="(item, i) in dataDocument.scopeMC" :key="item.Id" style="text-align:center;">
                            <td colspan="2">{{item.No_BoQ}}</td>
                            <td colspan="2">{{item.Scope}}</td>
                            <td style="text-align:center !important;">{{ item.Previous_Volume == null ? '' : $formatDecimal(item.Previous_Volume) }}</td>
                            <td style="text-align:center !important;">{{item.Previous_Unit}}</td>
                            <td style="text-align:center !important;">{{ item.Current_Volume == null ? '' : $formatDecimal(item.Current_Volume)}}</td>
                            <td style="text-align:center !important;">{{item.Current_Unit}}</td>
                            <td style="text-align:center !important;">{{ item.Deviasi_Volume == null ? '' : $formatDecimal(item.Deviasi_Volume)}}</td>
                            <td style="text-align:center !important;">{{item.Deviasi_Unit}}</td>
                            <td colspan="2">{{item.Remark}}</td>
                        </tr>
                        <tr style="height:15px;">
                            <td colspan="12" class="no-border"></td>
                        </tr>
                        <tr style="text-align:center;font-weight:bold;" class="signature-section">
                            <td colspan="4">Diajukan oleh,</td>
                            <td colspan="4">Diverifikasi oleh,</td>
                            <td colspan="4">Disetujui oleh,</td>
                        </tr>
                        <tr style="text-align:center;font-weight:bold;" class="signature-section">
                            <td colspan="4">
                                {{dataDocument!=null ? dataDocument.contractor:""}}
                            </td>
                            <td colspan="8">
                                {{dataDocument!=null ? dataDocument.Company:""}}
                            </td>
                        </tr>
                        <tr style="text-align:center;" class="signature-section">
                            <td colspan="2">
                                <br/><span class="fontsign">{{ dataDocument.Appr_Name1 }} </span> <br/>
                                <!-- <span>({{ dataDocument!=null ? dataDocument.Appr_Name1:"" }})</span> -->
                            </td>
                            <td colspan="2">
                                <br/><span class="fontsign">{{ dataDocument.Appr_Name2 }} </span> <br/>
                                <!-- <span>({{ dataDocument!=null ? dataDocument.Appr_Name2:"" }})</span> -->
                            </td>
                            <td colspan="2">
                                <br/><span class="fontsign">{{ dataDocument.Appr_Name3 }} </span> <br/>
                                <!-- <span>({{ dataDocument!=null ? dataDocument.Appr_Name3:"" }})</span> -->
                            </td>
                            <td colspan="3">
                                <br/><span class="fontsign">{{ dataDocument.Appr_Name4}} </span> <br/>
                                <!-- <span>({{ dataDocument!=null ? dataDocument.Appr_Name4:"" }})</span> -->
                            </td>
                            <td colspan="3">
                                <br/><span class="fontsign">{{ dataDocument.Appr_Name5 }} </span> <br/>
                                <!-- <span>({{ dataDocument!=null ? dataDocument.Appr_Name5:"" }})</span> -->
                            </td>
                        </tr>
                        <tr style="text-align:center;font-weight:bold;" class="signature-section">
                            <td colspan="2">
                                <span>{{this.$formatDateTime1(dataDocument.ApprDate1)}}</span>
                                <hr>
                                {{ labelAppr1 }}
                            </td>
                            <td colspan="2">
                                <span>{{this.$formatDateTime1(dataDocument.ApprDate2)}}</span>
                                <hr>
                                {{ labelAppr2 }}
                            </td>
                            <td colspan="2">
                                <span>{{this.$formatDateTime1(dataDocument.ApprDate3)}}</span>
                                <hr>
                                {{ labelAppr3 }}
                            </td>
                            <td colspan="3">
                                <span>{{this.$formatDateTime1(dataDocument.ApprDate4)}}</span>
                                <hr>
                                {{ labelAppr4 }}
                            </td>
                            <td colspan="3">
                                <span>{{this.$formatDateTime1(dataDocument.ApprDate5)}}</span>
                                <hr>
                                {{ labelAppr5 }}
                            </td>
                        </tr>
                        <tr style="height:15px;">
                            <td colspan="12" class="no-border"></td>
                        </tr>
                    </tbody>
                        <tr>
                            <td colspan="5" style="border: none;" class="tdfoot">
                                <img src="/assets/layout/images/stamp-draft.png" height="120" width="140" v-if="dataDocument.Status == this.$REQUEST_STATUS.DRAFT|| dataDocument.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL || dataDocument.Status == this.$APPROVAL_STATUS.REVISED"/>
                            </td>
                            <td colspan="7" style="border: none;" class="tdfoot">
                                <VueQrcode :value="valueLink" style="width:85px;float:right;" id="qr"></VueQrcode>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="12" style="border: none;" v-if="dataDocument.is_aproved">
                                <p style="font-size:10px;">
                                    <b>
                                        {{ 
                                            this.signBy(dataDocument)
                                        
                                        }}

                                    </b>
                                </p>
                            </td>
                        </tr>
                        <tr style="height: 30px;" v-if="dataDocument.is_aproved">
                            <td style="border: none;"></td>
                        </tr>
                        <tr style="height: 20px;" v-else>
                            <td style="border: none;"></td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import html2pdf from 'html2pdf.js'

export default{
data(){
    return {
        listDoc : null,
        dataheader : null,
        title : "listdocuments",
        docvalidity : [],
        compCode : "",
        dataDocument:null,
        listPicAppr:null,
        imgdocumentation : "",
        companydetail : null,
        is_receive :false,
        is_not_receive : false,
        valueLink : this.$store.getters.getUrlApp + this.$route.fullPath,
        labelAppr1 : "",
        labelAppr2 : "",
        labelAppr3 : "",
        labelAppr4 : "",
        labelAppr5 : "",
    }
},
methods:{
    signBy(data){
        this.signby = `${this.$DOCUMENTFOOTER.APPROVED_GENERATED} (Document Print by ${this.$store.getters.getFullname} at ${this.$formatDateTime2(new Date())})`; 
        return this.signby;
    },
    backToIndex(){
        if(this.$router.options.history.state.back != null)
                this.$router.push({ path: this.$router.options.history.state.back });
        else 
            this.$router.push({ path: "/MC/Index" });
    },
    downloadPrint(){
        this.$emit('block-ui');
            var self = this;
                const link = this.valueLink;
                this.$axios.get(this.$API_URL + "MC/" + "downloadprint", {
                responseType: 'blob',
                timeout: this.$AXIOS_TIMEOUT_LONG,
                params : {
                    id : this.id,
                    linqr : link,
                    signby : this.signby,
                }  
                })
                .then((response) => {
                    let fileName = response.headers["content-disposition"].split("filename=")[1].split(";")[0];

                    const blob = new Blob([response.data], { type: 'application/pdf' });
                    const url = URL.createObjectURL(blob);
                    window.open(url, '_blank');
                    self.$emit('unblock-ui');
                })
                .catch(function (err) {
                    self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: "File not found" + err, life: 120000});
                    self.blocked = false;
                    self.$emit('unblock-ui');
                });
    },
    printWindow() {
        this.addPagenumber();
        window.print();
        this.removePageNumbers();
    },
    addPagenumber(){
        let pageNumber = 1;
        var table = this.$refs.document;
        var scrollHeight = table.offsetHeight;
        var totalPages = Math.ceil(table.scrollHeight / 1123);
        for (let i = 0; i < totalPages; i++) {
            var pageNumberDiv = document.createElement("div");
            var pgNum = document.createTextNode("" + (i+1) + "/" + totalPages);
            pageNumberDiv.classList.add('page-number');
            pageNumberDiv.style.position = "absolute";
            pageNumberDiv.style.top = "calc((281mm - (0.5px + " + (i+1) +"px)) * " + (i+1)+ " - 31px)";
            pageNumberDiv.style.right = 0;
            pageNumberDiv.style.height = "12px";
            pageNumberDiv.appendChild(pgNum);
            document.body.appendChild(pageNumberDiv);
            
        }
    },
    removePageNumbers() {
        const pageNumberElements = document.querySelectorAll('.page-number');
        pageNumberElements.forEach(element => element.remove());
    },
    exportToPDF() {
        const filename = this.dataDocument ? `MC_${this.dataDocument.Doc_No}.pdf` : 'MC.pdf';
        html2pdf(this.$refs.document, {
            margin: [5, 8, 5, 8],
            filename: filename,
            image: { type: 'jpeg', quality: 0.98},
            html2canvas: { 
                scale: 2,
                useCORS: true,
                letterRendering: true
            },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
            pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
        })
    },
    getData() {
            this.$emit('block-ui');
            let self = this;
            self.$axios.get(this.$API_URL + "MC/getDataDoc/"+ this.$route.query.id 
            ).then((response) => {
                var data = response.data.data;
                self.dataDocument = data.document;
                self.listPicAppr = data.listPicAppr;
                var listAppr = self.listPicAppr;
                if(listAppr.length > 0)
                {
                        listAppr.forEach(a=>{
                            if(a.Sign_Position == 1){
                                self.labelAppr1 = a.Approval_As;
                                self.dataDocument.Appr_As1 = a.Approval_As;
                                self.dataDocument.Sign_Position1 =  a.Sign_Position;
                            }
                            else if(a.Sign_Position == 2){
                                self.labelAppr2 = a.Approval_As;
                                self.dataDocument.Appr_As2 = a.Approval_As;
                                self.dataDocument.Sign_Position2 =  a.Sign_Position;
                            }
                            else if(a.Sign_Position == 3){
                                self.labelAppr3 = a.Approval_As;
                                self.dataDocument.Appr_As3 = a.Approval_As;
                                self.dataDocument.Sign_Position3 =  a.Sign_Position;
                            }
                            else if(a.Sign_Position == 4){
                                self.labelAppr4 = a.Approval_As;
                                self.dataDocument.Appr_As4 = a.Approval_As;
                                self.dataDocument.Sign_Position4 =  a.Sign_Position;
                            }
                            else if(a.Sign_Position == 5){
                                self.labelAppr5 = a.Approval_As;
                                self.dataDocument.Appr_As5 = a.Approval_As;
                                self.dataDocument.Sign_Position5 =  a.Sign_Position;
                            }
                        });
                }
                self.$emit('unblock-ui');
            
            }).catch(function (err) {
                    self.$toast.add({ severity: 'error', summary: "Error", detail: err.message, life: 6000 });
                    self.$emit('unblock-ui');
            });
        },
    },
    computed:{
    },   
    created() {
            this.mode = this.$route.query.mode;
            this.id = this.$route.query.id ?? 0;
            this.getData();
        },
}
</script>
<style>

@page {
    size: A4 portrait !important;
    margin: 5mm 8mm;
  
    @top-left {
      content: "should be shown on the top-left";
      font-size: 15px;
      color: #979797;
      text-align: left;
    }

    @top-right{
        content: "should be shown on the top-left";
        font-size: 15px;
        color: #979797;
        text-align: left;
    }

    @bottom-right{
        content: "should be shown on the top-left";
        font-size: 15px;
        color: #979797;
        text-align: left;
    }
}

@media print {
    * {
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
    }
    
    body {
        float: none;
        margin: 0;
        padding: 0;
        counter-reset: section;
        width: 100%;
        background: white !important;
    }
    
    #content {
        display: table;
    }
    
    #pageFooter {
        display: table-footer-group;
    }
    
    #pageFooter:after {
        counter-increment: page;
        content: counter(page);
    }
   
    #app .layout-wrapper .p-blockui-container .layout-topbar{
        display: none;
    }

    #app .layout-wrapper .p-blockui-container .layout-sidebar{
        display: none;
        margin: 0;
    }

    #app .layout-wrapper .p-blockui-container .layout-footer{
        display: none;
        margin: 0;
    }

    #app .layout-wrapper .p-blockui-container .layout-main-container{
        padding: 0;
        margin: 0;
        width: 100%;
        background: white !important;
     }
     
    .surface-0 {
        margin: 0;
        padding: 0;
        background: white !important;
    }
    
    * {
        background: white !important;
    }
    
    #apps {
        background: white !important;
    }
    
    table {
        page-break-inside: auto;
    }
    
    tr {
        page-break-inside: avoid;
        page-break-after: auto;
    }
    
    thead {
        display: table-header-group;
    }
    
    tfoot {
        display: table-footer-group;
    }
}
@media screen and (max-width: 64em) {
    .p-sidebar-left.p-sidebar-lg,
    .p-sidebar-left.p-sidebar-md,
    .p-sidebar-right.p-sidebar-lg,
    .p-sidebar-right.p-sidebar-md {
        width: 20rem;
    }
}
#apps{
    width: 80%;
}

</style>
<style scoped>
@media print {
    tfoot {
      position: fixed;
      bottom: 0;
      width: 100%;
    }

    .tdfoot{
        width: 100%;
    }

    #toolbar{
        display: none;
    }
    #display{
        display: none;
    }

    body{
      width: 100%;
      margin: 0;
      padding: 0;
      background: white !important;
    }

    #apps{
        width: 100%;
        margin: 0;
        padding: 0;
    }
    
    .grid {
        margin: 0;
        padding: 0;
        background: white !important;
    }
    
    .col-12 {
        padding: 0;
        margin: 0;
        background: white !important;
    }
    
    .surface-0 {
        background: white !important;
        margin: 0;
        padding: 0;
    }
    
    .table td, .table th {
        padding: 1px 2px !important;
        font-size: 8px !important;
        line-height: 1.2;
    }
    
    .table {
        width: 100% !important;
    }
    
    .table thead th {
        font-size: 9px !important;
    }
    .pagebreak{
        page-break-after: always;
    }
    .tfoot{
        width: 97.20%;
        position: fixed;
        bottom: 0;
        left: 10px;
        right: 0;
    }
}
.table .no-border {
    border: none;
  }
.crossed
{
    background: linear-gradient(to bottom right, transparent 49.5%, black 49.5%, black 50.5%, transparent 50.5%) !important;
}

.table {
    border-collapse: collapse;
    width: 100%;
    color: black;
    table-layout: fixed;
}

/* Ensure equal column distribution for signature sections */
.signature-section {
    width: 100%;
}

.signature-section td {
    text-align: center !important;
    vertical-align: middle;
    padding: 2px 1px;
}

/* Force center alignment for all signature section content */
.signature-section {
    width: 100%;
    text-align: center;
}

.signature-section td, .signature-section th {
    text-align: center !important;
}

/* Force center alignment for table headers */
.table-header {
    text-align: center !important;
}

.table-header td, .table-header th {
    text-align: center !important;
    vertical-align: middle;
}
.table .th {
    padding-top: 12px;
    padding-bottom: 12px;
}
  /* #f9f340*/
.table .center{
    text-align: center;
}
.table td, .table th {
    border: 1px solid black;
    word-wrap: break-word;
    overflow-wrap: break-word;
    padding: 4px;
    vertical-align: top;
    text-align: left;
}

.table td[style*="text-align:center"], .table th[style*="text-align:center"] {
    text-align: center !important;
}

.ol {
    display: block;
    list-style-type: decimal;
    margin-block-start: 0px;
    margin-block-end: 0px;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 12px;
    margin-top:-10px;
}

hr{
    padding: 0.3px;
    border-bottom: 1.8px solid black;
    margin : 0 auto;
    width:110px;
   }



#toolbar{
    max-height: 90px;
}

.title{
    font-size: 20px;
}
.year{
    margin-left: 290px;
}
.center{
    margin: auto;
}
.p1 {
    width: 70%; /* Add a width to demonstrate text wrapping */
    margin: auto;
    white-space: normal;
    font-size:14px;
  }
  .widht1{
    width: 70%; /* Add a width to demonstrate text wrapping */
    margin: auto;
  }
  .fontsign{
    font-family: 'Monotype Corsiva'
  }
</style>